import { render } from "./TopLoadingBar.vue?vue&type=template&id=a2b447ec&scoped=true"
import script from "./TopLoadingBar.vue?vue&type=script&lang=js"
export * from "./TopLoadingBar.vue?vue&type=script&lang=js"

import "./TopLoadingBar.vue?vue&type=style&index=0&id=a2b447ec&scoped=true&lang=scss"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2b447ec"]])

export default __exports__